import React, { useState, useEffect } from 'react'

import { withRouter } from 'react-router-dom'

import { compose } from 'redux'
import { connect } from 'react-redux'
import { actionListTransaction } from '../../store/actions/transaction'

import {
  HistoryFilter,
  TransactionCard,
  TransactionModal,
  HistorySummary
} from './components'

const History = ({
  history,
  listTransaction,
  dispatchListTransaction
}) => {
  const [page, setPage] = useState(1)
  const [search, setSearch] = useState('')
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [activeSearch, setActiveSearch] = useState(null)
  const [modalTrx, setModalTrx] = useState(null)

  useEffect(() => {
    dispatchListTransaction({
      page,
      limit: 10,
      search: search || null,
      start_date: startDate || null,
      end_date: endDate || null
    })
  }, [dispatchListTransaction, page])

  const handleSearch = () => {
    setPage(1)
    if (search || startDate || endDate) {
      setActiveSearch({
        search: search || null,
        startDate: startDate || null,
        endDate: endDate || null
      })
    } else {
      setActiveSearch(null)
    }
    dispatchListTransaction({
      page: 1,
      limit: 10,
      search: search || null,
      start_date: startDate || null,
      end_date: endDate || null
    })
  }

  const handleResetSearch = () => {
    setSearch('')
    setStartDate('')
    setEndDate('')
    setActiveSearch(null)
    setPage(1)
    dispatchListTransaction({
      page: 1,
      limit: 10,
      search: null,
      start_date: null,
      end_date: null
    })
  }

  const renderSearchText = () => {
    if (!activeSearch) return null
    const parts = []
    if (activeSearch.search) parts.push(activeSearch.search)
    if (activeSearch.startDate && activeSearch.endDate) {
      parts.push(`dari ${activeSearch.startDate} sampai ${activeSearch.endDate}`)
    } else if (activeSearch.startDate) {
      parts.push(`dari ${activeSearch.startDate}`)
    } else if (activeSearch.endDate) {
      parts.push(`sampai ${activeSearch.endDate}`)
    }

    if (parts.length === 0) return null

    return `Pencarian : ${parts.join(' ')}`
  }

  const handlePageHome = () => {
    history.push('/')
  }

  const { loading, payload } = listTransaction
  const transactions = payload?.data || []
  const totalData = payload?.total || 0
  const totalPages = payload?.pages || 1

  return (
    <>
      <div className="breadcrumb-halaman">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a
                onClick={handlePageHome}
                className="clickable"
              >Beranda</a>
            </li>
            <li className="breadcrumb-item active">Riwayat transaksi</li>
          </ol>
        </nav>
      </div>

      <div className="container">
        <div className="cover-keranjang-all">
          <div className="cover-isi">
            <div className="cover-card-produk">
              <h2 className="judul">Riwayat transaksi</h2>

              <HistoryFilter
                search={search}
                setSearch={setSearch}
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
                handleSearch={handleSearch}
                handleResetSearch={handleResetSearch}
                activeSearch={activeSearch}
                renderSearchText={renderSearchText}
              />

              {loading ? (
                <div style={{ textAlign: 'center', padding: '40px 0', color: '#666' }}>
                  Memuat data transaksi...
                </div>
              ) : transactions.length === 0 ? (
                <div className="btn-bayar">
                  <p style={{ textAlign: 'center', marginBottom: '15px', color: '#888' }}>Belum ada riwayat transaksi.</p>
                  <a onClick={handlePageHome} className="btn-bayar">Belanja Sekarang!</a>
                </div>
              ) : (
                transactions.map((trx, index) => (
                  <TransactionCard
                    key={trx.id || index}
                    trx={trx}
                    onSelectTrx={(selectedTrx) => history.push(`/transaksi/detail/${selectedTrx.code}`)}
                  />
                ))
              )}

              {totalPages > 1 && (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', marginTop: '20px', marginBottom: '10px' }}>
                  <button
                    disabled={page <= 1}
                    onClick={() => setPage(p => Math.max(p - 1, 1))}
                    style={{
                      padding: '8px 16px',
                      borderRadius: '6px',
                      border: '1px solid #F5152C',
                      background: page <= 1 ? '#eee' : '#fff',
                      color: page <= 1 ? '#999' : '#F5152C',
                      fontWeight: 'bold',
                      cursor: page <= 1 ? 'not-allowed' : 'pointer',
                      outline: 'none'
                    }}
                  >
                    Sebelumnya
                  </button>
                  <span style={{ fontSize: '0.9em', color: '#555' }}>
                    Halaman {page} dari {totalPages}
                  </span>
                  <button
                    disabled={page >= totalPages}
                    onClick={() => setPage(p => Math.min(p + 1, totalPages))}
                    style={{
                      padding: '8px 16px',
                      borderRadius: '6px',
                      border: '1px solid #F5152C',
                      background: page >= totalPages ? '#eee' : '#F5152C',
                      color: page >= totalPages ? '#999' : '#fff',
                      fontWeight: 'bold',
                      cursor: page >= totalPages ? 'not-allowed' : 'pointer',
                      outline: 'none'
                    }}
                  >
                    Selanjutnya
                  </button>
                </div>
              )}
            </div>

            <HistorySummary
              totalData={totalData}
              page={page}
              totalPages={totalPages}
              setPage={setPage}
            />
          </div>
        </div>
      </div>

      <TransactionModal
        modalTrx={modalTrx}
        onClose={() => setModalTrx(null)}
      />
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    listTransaction: {
      loading: state.transaction?.listTransaction?.loading || false,
      payload: state.transaction?.listTransaction?.payload || null,
      error: state.transaction?.listTransaction?.error || null
    }
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatchListTransaction: (params) => dispatch(actionListTransaction(params))
  }
}

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(History)
